import { useEffect } from "react";

import useSearchSpaceliftVcsFiles from ".";

type UseSpaceliftVcsAllFilesProps = {
  repoId: string | undefined;
};

const useSpaceliftVcsAllFiles = ({ repoId }: UseSpaceliftVcsAllFilesProps) => {
  const { files, loading, error, hasMore, loadMore } = useSearchSpaceliftVcsFiles({ repoId });

  useEffect(() => {
    if (loading || !hasMore) return;

    loadMore();
  }, [loading, hasMore, loadMore]);

  return {
    files,
    loading: loading || hasMore,
    error,
  };
};

export default useSpaceliftVcsAllFiles;
